import { createSelector } from 'reselect'
import getUsersData from './getUsersData'

export default createSelector(
  getUsersData,
  (users) => Object.values(users || {}),
)
